<template>
  <div class="home">
    <div v-show="show">
      <tabbar></tabbar>
    </div>
    <homehead></homehead>
    <swipe></swipe>
    <navdh></navdh>
    <headline></headline>
    <courseone ></courseone>
    <coursetwo ></coursetwo>
    <coursethree ></coursethree>
    <coursefour></coursefour>
    <div class="kongbai"></div>
  </div>
</template>

<script>
import tabbar from '../../components/Tabbar'
import homehead from '../../components/HomeHead'
import swipe from '../../components/Swipe'
import navdh from '../../components/Navdh'
import headline from '../../components/Headline'
import courseone from '../../components/shouyeTongbu'
import coursetwo from '../../components/shouyeZhishidian'
import coursethree from '../../components/shouyeZhibo'
import coursefour from '../../components/shouyeZhuanti'
import URL from '../../api/index'
export default {
  components:{
    tabbar,
    homehead,
    swipe,
    headline,
    courseone,
    coursetwo,
    coursethree,
    coursefour,
    navdh
  },
  data() {
      return {
        screenHeight: document.documentElement.clientHeight,//屏幕高度
        show:true,
        firstTime:true,
        grade_id:0,
        ashow:true,
        phone:'',
      }
  },
  watch:{
    'screenHeight':function(){ //监听屏幕高度变化
      var oIframe = document.documentElement.clientHeight
    }
  },
  created(){
    if(localStorage.getItem("panduan")){
      this.getcode()
      localStorage.removeItem('panduan')
    }else{
    } 
  },
  mounted() {
    if(this.$route.query.identity){ // 孺教云跳转入口
      localStorage.setItem('identity',this.$route.query.identity)
      localStorage.setItem('trace',this.$route.query.trace)
      localStorage.setItem('apptrace',this.$route.query.apptrace)
      localStorage.setItem('product_name',this.$route.query.product_name)
    }

    if(this.$route.query.from){ //app内登录
      var code = '';
      var codeLength = 4;
      var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
      for (var i = 0; i < codeLength; i++) {
        var index = Math.floor(Math.random() * 9)
        code += random[index];
      }
      var userinfo = JSON.parse(localStorage.getItem('userInfo'))
      localStorage.setItem('trace',String(userinfo.user_id)+String(Date.parse(new Date())/1000)+code)
      localStorage.setItem('apptrace',String(userinfo.user_id)+String(Date.parse(new Date())/1000)+code)
    }

    this.phone = this.$route.query.mobile
    if(window.location.href.split('?mobile=')[1]){
      if(window.location.href.split('?mobile=')[1].split('&')[0] == 'pad'){
        localStorage.setItem("pad", JSON.stringify(true))
        AndroidJs.onUserLogin(
          localStorage.getItem("userInfo")
        )
      }else{
      }
    } else {
    }
    if (this.$route.query.mobile == 'pad') {
      AndroidJs.onUserLogin(
        localStorage.getItem("userInfo")
      );
    }else{
    }

    var _this = this;
    window.onresize = function(){ 
      _this.Height = document.documentElement.clientHeight;
      _this.conn(_this.Height)
    };
  },
  methods:{
    qiehuan(){
      this.ashow = false
    },
    getcode(){
      let url2 = window.location.href;
      var temp2 = url2.split('?')[1];
      var temp3 = url2.split('=')[1];
      if(temp3 !== undefined){
        var temp4 = url2.split('=')[1].slice(0,8)
        localStorage.setItem('form_id',temp4)
      }
      var arry = url2.substr(1).split('code')
      for (var i = 0; i < arry.length; i++) {
        var tmp = arry[i].split('&')
        var temp5 = tmp[0].split('=')[1]
        localStorage.setItem('code',temp5)  
        this.$axios({
        method:'post',
        url:URL.wxlogin,  
        data:{
          fromid : temp4,
          code : temp5
        }
        }).then((res)=>{
          console.log(res);
          if(res.data.result.mobile == '' || res.data.result.mobile == ' '){
            this.$router.push('/bangdingsj')
          }
          let userInfo = res.data.result
          localStorage.setItem("userInfo", JSON.stringify(userInfo))
        })
      }
    },
    conn(Height){
      if(this.screenHeight != Height){
        this.show = false
      } else{
        this.show =true
      }
    },
  },
}
</script>

<style scoped>
.kongbai{
  height: 60px;
}

@media screen and (width: 320px) {
  html{font-size: 24px!important;}
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue